import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import ReservationModal from '../components/ReservationModal';

const HomePage: React.FC = () => {
  const [bookingModalOpen, setBookingModalOpen] = useState(false);

  const handleOpenBookingModal = (e: React.MouseEvent) => {
    e.preventDefault();
    setBookingModalOpen(true);
  };

  const handleCloseBookingModal = () => {
    setBookingModalOpen(false);
  };

  return (
    <MainLayout>
      <section className="hero">
        <div className="hero-slider">
          <div className="slide current">
            <div className="content">
              <h1>Fallen Leaf Lodge</h1>
              <p>Your gateway to adventure on Fallen Leaf Lake</p>
              <div className="buttons">
                <Link to="/marina" className="btn primary">Explore Marina Services</Link>
                <Link to="/store" className="btn secondary">Visit Our Store</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-preview">
        <div className="container">
          <div className="image-col">
            <img src="/images/lodge-exterior.jpg" alt="Fallen Leaf Lodge Exterior" />
          </div>
          <div className="text-col">
            <h2>A Hidden Gem in South Lake Tahoe</h2>
            <p>Nestled on the shores of pristine Fallen Leaf Lake, our historic lodge has been serving visitors and locals alike since 1908. With breathtaking views of Mt. Tallac and surrounded by the natural beauty of the Sierra Nevada mountains, Fallen Leaf Lake offers a unique escape from the ordinary.</p>
            <p>Whether you're stopping in for supplies, enjoying a meal at our cafe, or exploring the lake from our marina, we're dedicated to making your experience memorable.</p>
            <Link to="/about" className="btn primary">Learn Our Story</Link>
          </div>
        </div>
      </section>

      <section className="services-preview">
        <div className="container">
          <h2 className="section-title">Explore Our Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <img src="/images/boat-rental.jpg" alt="Boat Rental" />
              <div className="service-content">
                <h3>Full-Service Marina</h3>
                <p>Powered and non-powered vessel rentals and everything you need to enjoy the crystal-clear waters of Fallen Leaf Lake. Secure seasonal moorings with easy access to all our amenities</p>
                <Link to="/marina#rentals" className="btn-link">View Options <i className="fas fa-arrow-right"></i></Link>
              </div>
            </div>
            <div className="service-card">
              <img src="/images/cafe-dining.jpg" alt="Cafe Dining" />
              <div className="service-content">
                <h3>Lakeside Dining</h3>
                <p>Enjoy delicious food, refreshing drinks, coffee and ice cream with breathtaking views of Fallen Leaf Lake.</p>
                <Link to="/cafe" className="btn-link">See Menu <i className="fas fa-arrow-right"></i></Link>
              </div>
            </div>
            <div className="service-card">
              <img src="/images/general-store.jpg" alt="General Store" />
              <div className="service-content">
                <h3>General Store</h3>
                <p>From essentials to souvenirs, our well-stocked general store has everything you need for your lake adventure.</p>
                <Link to="/store" className="btn-link">Shop Now <i className="fas fa-arrow-right"></i></Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials">
        <div className="container">
          <h2 className="section-title">What Our Visitors Say</h2>
          <div className="testimonial-slider">
            <div className="testimonial">
              <div className="stars">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
              </div>
              <p className="quote">"Fallen Leaf Lodge is a true hidden gem! The cafe food was delicious, and renting a kayak to explore the lake was the highlight of our trip. Can't wait to come back!"</p>
              <p className="author">- Sarah T., San Francisco</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta">
        <div className="container">
          <h2>Ready for Your Fallen Leaf Lake Adventure?</h2>
          <p>Book your boat rental, mooring, or plan your visit today!</p>
          <button onClick={handleOpenBookingModal} className="btn primary">Make a Reservation</button>
          <Link to="/contact" className="btn secondary">Contact Us</Link>
        </div>
      </section>

      {/* Booking Modal */}
      <ReservationModal open={bookingModalOpen} onClose={handleCloseBookingModal} />
    </MainLayout>
  );
};

export default HomePage; 